
import {
    FETCH_ENDPOINTS,
    FETCH_ENDPOINT_SUCCESS,
    FETCH_ENDPOINT_FAILURE,
    FETCH_PROGRAMS
  } from "../../../constants/action";
  
  const initialState = {
    endpoints: [],
    programs: [],
    loading: false,
    error: null,
  };
  
  const mapperReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ENDPOINTS:
        return {
            ...state,
            loading: false,
            error: null,
        };
        case FETCH_ENDPOINT_SUCCESS:
      
        return {
          ...state,
          endpoints: action.payload,
          loading: false,
          error: null,
        };
      case FETCH_ENDPOINT_FAILURE:
        return {
          ...state,
          endpoints: null,
          loading: false,
          error: action.payload,
        };
        case FETCH_PROGRAMS:
        return {
          ...state,
          programs: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default mapperReducer;